import {JsonProperty} from '../shared/decorators/json-property';
import {calculateTime} from '../shared/utils/helper';

export class Customer {
  @JsonProperty('user_id')
  id: number;
  email: string;
  type: number;
  active: number;
  @JsonProperty('is_verify_email')
  verifiedEmail: boolean;
  @JsonProperty('total_balance')
  totalBalance: number;
  @JsonProperty('total_profit')
  totalPNL: number;
  @JsonProperty('total_volume')
  totalVolume: number;
  @JsonProperty('total_order')
  totalOrder: number;
  @JsonProperty('kyc_status')
  kyc: number;
  @JsonProperty('image_kyc_url')
  kycImage: string;
  @JsonProperty('image_kyc_address_url')
  kycAddress: string;
  @JsonProperty('create_time')
  createdDate: number;
  @JsonProperty('ib_id')
  ibId: number;
  bonus: number;
  @JsonProperty('mt5_account')
  mt5Account: number;
  @JsonProperty('mt5_create_time')
  mt5CreateTime: number;
  @JsonProperty('first_name')
  firstName: string;
  @JsonProperty('middle_name')
  middleName: string;
  @JsonProperty('last_name')
  lastName: string;
  @JsonProperty('first_name_jp')
  firstNameJP: string;
  @JsonProperty('last_name_jp')
  lastNameJP: string;
  country: string;
  withdraw: number;
  deposit: number;
  @JsonProperty('net_asset')
  netAsset: number;
  @JsonProperty('realized_pnl')
  realizedPnl: number;
  @JsonProperty('currency')
  currency: string;
  @JsonProperty('is_mam') isMam: number;
  @JsonProperty('total_bonus_used')
  total_bonus_used: number;
  @JsonProperty('total_profit_by_bonus')
  total_profit_by_bonus: number;
  @JsonProperty('user_type')
  userType: number;
  @JsonProperty('total_account') total_account: number;
  constructor() {
    this.active = undefined;
    this.userType = 0;
    this.isMam = undefined;
    this.id = undefined;
    this.email = undefined;
    this.type = undefined;
    this.verifiedEmail = undefined;
    this.totalBalance = undefined;
    this.totalPNL = undefined;
    this.totalVolume = undefined;
    this.totalOrder = undefined;
    this.kyc = undefined;
    this.kycImage = undefined;
    this.kycAddress = undefined;
    this.createdDate = undefined;
    this.bonus = undefined;
    this.ibId = undefined;
    this.firstName = undefined;
    this.middleName = undefined;
    this.lastName = undefined;
    this.firstNameJP = undefined;
    this.lastNameJP = undefined;
    this.country = undefined;
    this.deposit = undefined;
    this.withdraw = undefined;
    this.netAsset = undefined;
    this.realizedPnl = undefined;
    this.mt5Account = undefined;
    this.mt5CreateTime = undefined
    this.currency = undefined;
    this.total_bonus_used = undefined;
    this.total_profit_by_bonus = undefined;
    this.total_account = undefined;
  }

  getUsername(): string {
    return this.firstName + ' ' + this.lastName;
  }
  getUsernameJP(): string {
    return ((this.firstNameJP) ? this.firstNameJP : '') + ' ' + ((this.lastNameJP) ? this.lastNameJP : '');
  }

  getActivation(): string {
    const numberOfDay = calculateTime(
      this.createdDate,
      new Date().getTime(),
      'd',
    );
    return this.verifiedEmail
      ? 'Yes'
      : numberOfDay + (numberOfDay >= 2 ? ' days ' : ' day ') + 'ago';
  }

  getKYC(): string {
    switch (this.kyc) {
      case -1:
        return '<span class="text-muted">Unuploaded</span>';
      case 0:
        return '<span class="text-primary">Uploaded</span>';
      case 1:
        return '<span class="text-green">Approved</span>';
      case 2:
        return '<span class="text-red">Rejected</span>';
    }
  }
  getKYCByText() {
    const kyc = {
      '-1': 'Unuploaded',
      0: 'Uploaded',
      1: 'Approved',
      2: 'Rejected'
    }
    return kyc[this.kyc];
  }
  getTextKYC(): string {
    switch (this.kyc) {
      case -1:
        return 'Unuploaded';
      case 0:
        return 'Uploaded';
      case 1:
        return 'Verified';
      case 2:
        return 'Rejected';
    }
  }
  getPercentBalanceRatio(): string {
    if (this.totalBalance !==  0 && this.totalPNL !== 0) {
      return ((this.totalPNL / this.totalBalance) * 100).toFixed(2) + ' %';
    }
    return '0';
  }
}


export interface ExportXLSXProps<T = any> {
  header: string[][];
  data: T[];
  filename?: string
}
